import { IDictionary } from '../types/common'

export function formatQueryString(object: IDictionary<string | number | undefined | null>) {
    return Object.entries(object)
        .filter(([key, value]) => value !== null && value !== undefined)
        .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
        .join('&')
}

export const ggsGetQueryParams = (): string => {
    return ggsGetQueryParameters()
}

export const ggsGetReferrerValue = (): string => {
    return ggsGetReferrer()
}
